import { render, staticRenderFns } from "./ProblemReasonAdd.form.vue?vue&type=template&id=1280b108&"
import script from "./ProblemReasonAdd.form.vue?vue&type=script&lang=js&"
export * from "./ProblemReasonAdd.form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports